var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "take-card" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", [
        _vm._v("¥"),
        _c("span", { staticClass: "amount" }, [_vm._v(_vm._s(_vm.reduceCost))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "num" }, [
        _vm._v("×" + _vm._s(_vm.card.num || 1))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", [_vm._v(_vm._s(_vm.card.title))]),
      _vm._v(" "),
      _c("div", [_vm._v("满" + _vm._s(_vm.card.least_cost) + "元可用")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.effectDate))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8308e664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8308e664","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TakeCardItem.vue
// module id = PeiJ
// module chunks = 15